var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultimedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0855 7.73855L34.6404 6.40354L32.5432 14.6211L26.9883 15.9561L29.0855 7.73855Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0059 12.5873L35.2329 13.9747L37.3301 5.75714L39.2533 5.29492L41.0059 12.5873Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3958 8.38496L20.8378 9.72072L18.7406 17.9383L24.2987 16.6025L26.3958 8.38496Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4337 11.7405L18.1481 10.3671L16.051 18.5847L10.3365 19.9581L12.4337 11.7405Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74399 12.3869L4.25 13.7073L6.00254 20.9995L6.00195 25.4995H42.002V20.9995H6.00254L7.64681 20.6045L9.74399 12.3869Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00195 26.9995H42.002V41.9995H6.00195V26.9995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimedia);
export default __webpack_public_path__ + "static/media/multimedia.2a6b8deca6f59156d6e4b6ee757ae052.svg";
export { ForwardRef as ReactComponent };